export default __webpack_public_path__ + "static/media/gridImage6.74cebcbf.png";